export default __webpack_public_path__ + "static/media/payment.inline.888697a6.svg";